import { useForm } from "react-hook-form";
import { useState } from "react";
import { useRouter } from "next/router";
import ScrollContainer from "react-perfect-scrollbar";
import { FormSubmitButton } from "./FormSubmitButton";
import ModalReturnIcon from "../assets/images/_modal__return.svg";
import { useToast } from "~/utils";
import classnames from "classnames";
import { useSignInMutation } from "~/hooks/rtk-query-api";

export const NeedReauthenticateModal = ({ user, onFinish }) => {
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [signIn] = useSignInMutation();
  const onSubmit = async (data: { current_password: string }) => {
    setLoading(true);
    try {
      await signIn({
        signInInput: { email: user.email, password: data.current_password },
      }).unwrap();
      onFinish();
    } catch (e) {
      if (e.status === 401) {
        toast.error("認証に失敗しました。パスワードをご確認ください");
      } else {
        toast.error(e.data?.message ?? "エラーが発生しました。お手数ですがもう一度時間を開けておためしください。");
      }
    } finally {
      setLoading(false);
    }
  };

  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  return (
    <div
      className={classnames([
        "_modal__wrapper",
        {
          show: open,
        },
      ])}
      data-test="need-reauthenticate-modal"
    >
      <ScrollContainer>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="_modal">
            <div className="header">パスワードの再入力</div>
            <div className="content">
              <p>セキュリティのためパスワードを入力してください</p>
              <div className="_form">
                <div className="field">
                  <label>
                    <span className="label">パスワード</span>
                    <input
                      type="password"
                      placeholder="●●●●●●●●"
                      {...register("current_password", {
                        required: true,
                      })}
                      style={{ width: "100%" }}
                      autoFocus={true}
                      data-test="need-reauthenticate-modal-input"
                    />
                  </label>
                  {errors.current_password && <span className="sub red">現在のパスワードを入力してください</span>}
                </div>
              </div>
              <p></p>
            </div>
            <div className="footer right">
              <FormSubmitButton size="medium" loading={loading} test="need-reauthenticate-modal-submit">
                認証して進む
              </FormSubmitButton>
            </div>
            <div
              className="_modal__close"
              onClick={() => {
                setOpen(false);
                router.back();
              }}
            >
              <ModalReturnIcon />
            </div>
          </div>
        </form>
      </ScrollContainer>
    </div>
  );
};
